var _style, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFab = function SvgFab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fab_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fab_svg__st1{fill:currentColor}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fab_svg__st1",
    d: "M32.28 13.87H15.72c-2.56 0-4.64 2.08-4.64 4.64v9.75c0 2.56 2.08 4.64 4.64 4.64h7.33l5.16 5.16a.894.894 0 0 0 1.26 0c.35-.35.35-.91 0-1.26l-5.49-5.49a.888.888 0 0 0-.62-.26v-.01h-7.63c-1.53 0-2.78-1.25-2.78-2.78v-9.75c0-1.53 1.25-2.78 2.78-2.78h16.56c1.53 0 2.78 1.25 2.78 2.78v9.75c0 1.53-1.25 2.78-2.78 2.78h-1.32v1.86h1.32c2.56 0 4.64-2.08 4.64-4.64v-9.75c-.02-2.56-2.1-4.64-4.65-4.64z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fab_svg__st1",
    cx: 19.14,
    cy: 23.46,
    r: 1.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fab_svg__st1",
    cx: 23.98,
    cy: 23.47,
    r: 1.48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fab_svg__st1",
    cx: 28.82,
    cy: 23.48,
    r: 1.48
  })));
};
export { SvgFab as ReactComponent };
export default "data:image/svg+xml,%3c!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e %3csvg version='1.1' id='Lager_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 48 48' style='enable-background:new 0 0 48 48;' xml:space='preserve'%3e %3cstyle type='text/css'%3e .st1%7bfill:currentColor;%7d %3c/style%3e %3cg%3e %3cpath class='st1' d='M32.28,13.87H15.72c-2.56,0-4.64,2.08-4.64,4.64v9.75c0,2.56,2.08,4.64,4.64,4.64h7.33l5.16,5.16 c0.17,0.17,0.4,0.26,0.63,0.26c0.23,0,0.45-0.09,0.63-0.26c0.35-0.35,0.35-0.91,0-1.26l-5.49-5.49c-0.17-0.17-0.4-0.26-0.62-0.26 v-0.01h-7.63c-1.53,0-2.78-1.25-2.78-2.78v-9.75c0-1.53,1.25-2.78,2.78-2.78h16.56c1.53,0,2.78,1.25,2.78,2.78v9.75 c0,1.53-1.25,2.78-2.78,2.78h-1.32v1.86h1.32c2.56,0,4.64-2.08,4.64-4.64v-9.75C36.91,15.95,34.83,13.87,32.28,13.87z'/%3e %3ccircle class='st1' cx='19.14' cy='23.46' r='1.48'/%3e %3ccircle class='st1' cx='23.98' cy='23.47' r='1.48'/%3e %3ccircle class='st1' cx='28.82' cy='23.48' r='1.48'/%3e %3c/g%3e %3c/svg%3e";